import { DataModelBuilder, SerializationContext, SerializedData } from '../../../dto/data-model.js';
import { Payload } from '../payload.js';
import { PayloadType } from '../payload-type.js';
import { MapUtils } from '../../../../utility/map-utils.js';
import { SeatPreviewState } from '../../seating-preview/seat-preview-state.js';
import { JSONUtils } from '../../../../utility/json-utils.js';
import { cloneListOfCloneable, isSameList, isSameData } from '../../../dto/data-model-utils.js';

export class SeatPreviewStatesChangedPayload extends Payload {
  static readonly TYPE_ID = 'eb27a2cfe9574d34b605dd82689224c4';

  private constructor(
    public readonly seatPreviewStates: SeatPreviewState[] | null,
  ) {
    super();
  }

  get $typeId(): string {
    return SeatPreviewStatesChangedPayload.TYPE_ID;
  }

  get type(): PayloadType {
    return PayloadType.SeatPreviewStatesChanged;
  }

  static create(args: {
    seatPreviewStates: SeatPreviewState[] | null;
  }): SeatPreviewStatesChangedPayload {
    return new SeatPreviewStatesChangedPayload(args.seatPreviewStates);
  }

  static fromMap(context: SerializationContext, map: SerializedData): SeatPreviewStatesChangedPayload {
    return SeatPreviewStatesChangedPayload.create({
      seatPreviewStates: MapUtils.getListOrNull<SeatPreviewState>(map, 'seatPreviewStates', (value) => context.fromData<SeatPreviewState>(JSONUtils.decodeRecord(value))),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'seatPreviewStates': this.seatPreviewStates?.map((value) => context.toData(value)) ?? null,
    };
  }

  clone(): this {
    return this.copyWith();
  }

  copyWith({
    seatPreviewStates = this.seatPreviewStates == null ? null : cloneListOfCloneable(this.seatPreviewStates),
  }: {
    seatPreviewStates?: SeatPreviewState[] | null;
  } = {}): this {
    return SeatPreviewStatesChangedPayload.create({ seatPreviewStates }) as this;
  }

  isSame(other: SeatPreviewStatesChangedPayload): boolean {
    return this === other || (
      isSameList(this.seatPreviewStates, other.seatPreviewStates, isSameData)
    );
  }
}

export class SeatPreviewStatesChangedPayloadBuilder extends DataModelBuilder<SeatPreviewStatesChangedPayload> {
  build(context: SerializationContext, map: SerializedData): SeatPreviewStatesChangedPayload {
    return SeatPreviewStatesChangedPayload.fromMap(context, map);
  }
}
